module.exports = __webpack_public_path__ + "static/media/coworking-dollhouse.37741f29.png";